<template>
  <header class="app-header">
    <nav class="main-nav">
      <ul>
        <li v-for="item in displayedMenuItems" :key="item.name">
          <router-link :to="{ name: item.name, params: { lang: currentLanguage, levelId: item.levelId } }"
                       :class="{ 'active-level': item.levelId && activeLevel === item.levelId }">
            {{ item.title }}
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="language-switcher">
      <button @click="setLanguageAndNavigate('en')" :class="{ active: currentLanguage === 'en' }">EN</button>
      <button @click="setLanguageAndNavigate('de')" :class="{ active: currentLanguage === 'de' }">DE</button>
      <button @click="setLanguageAndNavigate('ru')" :class="{ active: currentLanguage === 'ru' }">RUS</button>
      <button @click="setLanguageAndNavigate('ua')" :class="{ active: currentLanguage === 'ua' }">UA</button>
      <button @click="setLanguageAndNavigate('hy')" :class="{ active: currentLanguage === 'hy' }">ARM</button>
    </div>
  </header>
</template>

<script>
import { languageStore } from '../languageStore';
import { useRouter } from 'vue-router';
import { watch, ref, computed } from 'vue';

export default {
  name: 'AppHeader',
  setup() {
    const router = useRouter();
    const currentLanguage = ref(languageStore.currentLanguage);
    const menuItems = ref([]);
    const localeContent = ref({});

    const loadMenu = async (lang) => {
      try {
        const module = await import(`../locales/menu/menu_${lang}.json`);
        const localeModule = await import(`../locales/components/AppHeader_${lang}.json`);
        localeContent.value = localeModule.default;
        // Если импортирован объект, преобразуем его в массив
        if (Array.isArray(module.default)) {
          menuItems.value = module.default;
        } else if (typeof module.default === 'object' && module.default !== null) {
          menuItems.value = Object.values(module.default);
        } else {
          menuItems.value = [];
        }
        console.log('Loaded menu items for', lang, ':', menuItems.value);
      } catch (error) {
        console.error(localeContent.value.failedToLoadMenuItems || 'Failed to load menu items:', error);
        menuItems.value = [];
      }
    };

    watch(() => router.currentRoute.value.params.lang, (newLang) => {
      if (newLang) {
        currentLanguage.value = newLang;
        languageStore.setLanguage(newLang);
        loadMenu(newLang);
      }
    }, { immediate: true });



    const activeLevel = computed(() => {
      return router.currentRoute.value.params.levelId;
    });

    const isLevelActive = computed(() => {
      return !!activeLevel.value;
    });

    const displayedMenuItems = computed(() => {
      if (isLevelActive.value) {
        return menuItems.value.filter(item => !item.levelId || item.levelId === activeLevel.value);
      } else {
        return menuItems.value.filter(item => !item.levelId);
      }
    });

    const setLanguageAndNavigate = (lang) => {
      languageStore.setLanguage(lang);
      const currentRoute = router.currentRoute.value;
      router.push({ name: currentRoute.name, params: { ...currentRoute.params, lang: lang } });
    };

    return {
      currentLanguage,
      setLanguageAndNavigate,
      activeLevel,
      // menuItems,
      displayedMenuItems,
      localeContent,
    };
  },
};
</script>

<style scoped>
.app-header {
  /* Basic styling for the header */
  background-color: #f8f8f8;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
  gap: 1rem;
}

.main-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 1.5rem;
}

.main-nav li {
  /* Margin handled by gap on ul */
}

.main-nav a {
  text-decoration: none;
  color: #333;
  font-weight: bold;
}

.main-nav a:hover {
  color: #007bff;
}

.main-nav li.active a {
  color: #007bff; /* Active link color */
}

.main-nav a.active-level {
  color: #007bff; /* Highlight color for active level */
  border-bottom: 2px solid #007bff;
}

.language-switcher {
  display: flex;
  gap: 0.5rem;
}

.language-switcher button {
  background: none;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 5px;
}

.language-switcher button:hover {
  background-color: #eee;
}

.language-switcher button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

@media (max-width: 768px) {
  .app-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 0.75rem 0.5rem;
    gap: 0.75rem;
  }
  .main-nav ul {
    flex-wrap: wrap;
    gap: 0.75rem;
  }
  .language-switcher {
    flex-wrap: wrap;
    gap: 0.35rem;
  }
  .language-switcher button {
    padding: 0.35rem 0.6rem;
    font-size: 0.85rem;
  }
}
</style>
